import { http } from "./client";

/** Read the singleton site settings. */
export async function getSettings() {
  const { data } = await http.get("/api/v1/admin/settings/");
  return data.data;
}

/** Patch site settings (e.g. the contact notification email). */
export async function updateSettings(payload) {
  const { data } = await http.patch("/api/v1/admin/settings/", payload);
  return data.data;
}

/**
 * Read the editable site footer (contact details + per-locale office lists),
 * pre-filled with the live values. Returned as part of the settings payload.
 */
export async function getFooter() {
  const { data } = await http.get("/api/v1/admin/settings/");
  return data.data.footer;
}

/** Save the site footer. Triggers a public-site rebuild server-side. */
export async function updateFooter(footer) {
  const { data } = await http.patch("/api/v1/admin/settings/", { footer });
  return data.data.footer;
}

/**
 * Manually trigger the public-site rebuild (the 發佈更新 button). Used after
 * saving edits to already-published content, since plain saves deliberately
 * don't deploy. Returns { triggered } — false in local dev (no webhook).
 */
export async function triggerRebuild() {
  const { data } = await http.post("/api/v1/admin/rebuild/");
  return data.data;
}

/**
 * Latest run of the public-frontend deploy workflow, for the post-發佈更新
 * progress indicator. Returns { available, run: { id, status, conclusion,
 * created_at, updated_at, html_url } | null }.
 */
export async function getRebuildStatus() {
  const { data } = await http.get("/api/v1/admin/rebuild/status/");
  return data.data;
}

/**
 * Published content saved since the last deploy — changes the static site
 * doesn't show yet. Powers the page-wide「尚未發佈」bar.
 * Returns { since, count, items: [{ type, id, label, updated_at }] }.
 */
export async function getPendingChanges() {
  const { data } = await http.get("/api/v1/admin/pending-changes/");
  return data.data;
}

/**
 * Read the public sitemap: every published URL (pages + events) plus the live
 * sitemap.xml / robots.txt locations. Public endpoint, shared with the Nuxt
 * build; the settings page renders it so staff can see what search engines index.
 */
export async function getSitemap() {
  const { data } = await http.get("/api/v1/sitemap/");
  return data.data;
}
